import {Settings} from '@fantasmagames/slot/src/common/settings/Settings';
import {RecodeEvents} from '@fantasmagames/slot/src/integration/RecodeEvents';
import {SettingsModule} from '@fantasmagames/slot/src/modules/mainmenu/settingsmenu/SettingsModule';

export class RecodeSettingsModule extends SettingsModule {
	public init(): void {
		super.init();

		this.checkCertificationForFastPlay();
	}

	protected checkCertificationForFastPlay(): void {
		if ((window as any)._certificationSettings && (window as any)._certificationSettings.hasOwnProperty('quickSpins')) {
			const quickspinAvailable: boolean = (window as any)._certificationSettings.quickSpins;

			this.settings.add(Settings.IS_QUICKSPIN_AVAILABLE, quickspinAvailable);
		}
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.on(RecodeEvents.SERVER_PLUGIN_SET_MUTE, this.onServerSetMute);

		// Maybe we just shove the last user setting down the top bar throat since it doesn't seem to serve a usable value.
		// this.onServerSetMute(null, (window as any).V.API.Core.isSoundMuted());
	}

	protected onServerSetMute(eventId: string, mute: boolean): void {
		// mute = !mute; // They send the inverted value for some reason which is unexplainable.
		mute ? this.onAllSoundOff(null, true) : this.onAllSoundOn(null, true);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/mainmenu/settingsmenu/recode/RecodeSettingsModule.ts